export default __webpack_public_path__ + "static/media/contactSide.5100d3af.jpg";